import React, { memo, useCallback } from 'react'
import IconButton from '../common/IconButton';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { solid } from '@fortawesome/fontawesome-svg-core/import.macro';
import classNames from 'classnames';

type Props = {
  prompt: string;
  onPromptChange?: (value: string) => void;
  onSendMessage?: Function;
  disabled?: boolean;
}

function ChatInput({ prompt, disabled, onPromptChange, onSendMessage }: Props) {

  const handlePromptChange = useCallback((evt: React.ChangeEvent<HTMLInputElement>) => {
    onPromptChange?.(evt.target.value);
  }, [onPromptChange]);

  const handleSendMessage = useCallback((evt: React.MouseEvent<HTMLButtonElement> | React.FormEvent<HTMLFormElement>) => {
    evt.stopPropagation?.();
    evt.preventDefault?.();
    onSendMessage?.(prompt);
  }, [prompt, onSendMessage]);

  return (
    <form onSubmit={handleSendMessage}>
      <div className={classNames("chat-input-wrapper", { disabled })}>
        <input
          className="chat-input"
          placeholder="Type message here..."
          value={prompt}
          onChange={handlePromptChange}
          autoFocus
          disabled={disabled}
        />

        <IconButton
          type="submit"
          disabled={disabled || !prompt.length}
          className="chat-input-submit"
          tooltip="Send Message"
          onClick={handleSendMessage}
        >
          <FontAwesomeIcon icon={solid('arrow-alt-circle-up')} size="lg" />
        </IconButton>
      </div>
    </form>
  )
}

export default memo(ChatInput);